import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import './assets/fonts/inter/inter.css';
import './assets/icons/phosphor/styles.min.css';
import './assets_layout/css/ltr/all.min.css';
import './utils/DatePickerSetup.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './assets_layout/css/ltr/all.min.css';
import './assets_layout/css/ltr/layout.min.css';
import './App.css';







import App from './App';
import reportWebVitals from './reportWebVitals';

import './assets_layout/js/app.js';

serviceWorkerRegistration.register();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
